import Image from 'next/image';
import config from '@/config';

export default function Logo() {
  return (
    <Image
      src="/logo-light2.png"
      alt={`${config.appName} logo`}
      className="w-8"
      priority={true}
      width={32}
      height={32}
    />
  );
}
